import { render, staticRenderFns } from "./ship.vue?vue&type=template&id=3b55884a"
import script from "./ship.vue?vue&type=script&lang=js"
export * from "./ship.vue?vue&type=script&lang=js"
import style0 from "./ship.vue?vue&type=style&index=0&id=3b55884a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports